import "./Showroom.css";
import workstations from "../media/images/workstations.jpg";
import { useState } from "react";
const Showroom = () => {
    const [currentlyC, setC]=useState("all");
    const products =[
        {name:"Karakuri",image:workstations,type:"karakuri"},
        {name:"carts",image:workstations,type:"carts"},
        {name:"rack",image:workstations,type:"rack"},
        {name:"workplace",image:workstations,type:"workplace"},
        {name:"others",image:workstations,type:"others"},
        {name:"roller",image:workstations,type:"roller"},
    ]

    return (  
        <div className="showroom">
            <div style={{ backgroundColor: "#464745", height:"7vh"}}>
            </div>
            <div className="showroomContainer">
                <div className="filters">
                     <h2>Categories</h2>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("all")}}/>
                    <span class="custom-radio"></span>
                    ALL
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("carts")}}/>
                    <span class="custom-radio"></span>
                    Carts & Trolleys
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("rack")}}/>
                    <span class="custom-radio"></span>
                    Rack Systems
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("workplace")}}/>
                    <span class="custom-radio"></span>
                    Workplace Systems
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("others")}}/>
                    <span class="custom-radio"></span>
                    Others
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("roller")}}/>
                    <span class="custom-radio"></span>
                    Roller Conveyors
                </label>
                <label class="radio-container">
                    <input type="radio" name="category" onChange={()=>{setC("karakuri")}}/>
                    <span class="custom-radio"></span>
                    Karakuri
                </label>
                </div>
                <div className="products">
                    <h2>X products found</h2>
                    <div className="productsContainer">
                        {products.map((item,index)=>(
                        <div className="productBox" style={{display:currentlyC===item.type || currentlyC==="all"?"flex":"none"}}>
                            <p>{item.name}</p>
                            <img src={item.image} alt="s"/>
                            <button>VIEW PRODUCT</button>
                        </div> 
                        ))}                    
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Showroom;